module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.metadata && _vm.metadata.filterScopeLabel) ? _c('div', {
    staticClass: "report-metadata"
  }, [_c('span', {
    staticClass: "label label-info"
  }, [_vm._v(_vm._s(_vm.metadata.filterScopeLabel))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3fefefe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ReportFilterBadge.vue
// module id = 763
// module chunks = 1